import { render, staticRenderFns } from "./UiCameraDescription.vue?vue&type=template&id=6af0ddcc&scoped=true"
import script from "./UiCameraDescription.vue?vue&type=script&lang=js"
export * from "./UiCameraDescription.vue?vue&type=script&lang=js"
import style0 from "./UiCameraDescription.vue?vue&type=style&index=0&id=6af0ddcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af0ddcc",
  null
  
)

export default component.exports